<template>
    <v-container>
        <v-card min-width="100%">
            <v-card-title>
                {{ title }}
            </v-card-title>
                <v-card-text>
                    <v-form v-model="valid">

                    <error-badge :value="error" ref="errors"></error-badge>

                    <v-container v-if="errors.length > 0">
                        <div class="alert alert-danger">
                            <ul>
                                <li v-for="(error, ierr) in errors" :key="ierr">{{ error }}</li>
                            </ul>
                        </div>
                    </v-container>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12">
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" class="formSubSection">
                                <h3>{{ trans('users_targets_progressions.fields.target_section') }}</h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.name') }}</b> : {{ data.target_name }}
                            </v-col>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.type') }}</b> : {{ trans('targets.values.type.' + data.target_type) }}
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.deadline') }}</b> : {{ data.target_deadline | date }}
                            </v-col>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.priority') }}</b> : {{ trans('targets.values.priority.' + data.target_priority) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.hourly_budget') }}</b> : {{ data.target_hourly_budget }}
                            </v-col>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.allocated_time') }}</b> : {{ data.target_allocated_time / 3600 }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <b>{{ trans('targets.fields.user_target_worked_time') }}</b> : {{ data.user_target_worked_time }} - {{ human_worked_time(data.user_target_worked_time_sec) }}
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <div><b>{{ trans('targets.fields.description') }}</b>:</div>
                                <p>{{ data.target_description }}</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" class="formSubSection">
                                <h3>{{ trans('users_targets_progressions.fields.user_section') }}</h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <b>{{ trans('users.fields.name') }}</b> : {{ data.user_name }}
                            </v-col>
                            <v-col cols="6" md="6">
                                <b>{{ trans('users.fields.email') }}</b> : {{ data.user_email }}
                            </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="6" md="6">
                                <b>{{ trans('companies.fields.name') }}</b> : {{ data.company_name }}
                            </v-col>

                        </v-row>
                        <v-row>

                            <v-col cols="12" md="12" class="formSubSection">
                                <h3>{{ trans('targets.fields.activities') }}</h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>{{ trans('activities.fields.name') }}</th>
                                                <th>{{ trans('activities.fields.deadline') }}</th>
                                                <th>{{ trans('activities.fields.allocated_time') }}</th>
                                                <!-- <th>{{ trans('users_activities.fields.worked_time') }}</th>
                                                    <th>{{ trans('users_activities.fields.started') }}</th>
                                                    -->
                                                <th>{{ trans('users_activities.fields.ended') }}</th>
                                                <th v-if="show_user_performance === true">Op.</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(activity, aid) in activities" :key="aid">
                                                <td>{{ activity.name }}</td>
                                                <td>{{ activity.deadline | date }}</td>
                                                <td>{{ activity.allocatedTime / 3600 }}</td>
                                                <!--
                                                <td>{{ activity.worked_time }}</td>
                                                <td>{{ activity.started }}</td>
                                                -->
                                                <td><template v-if="has_restart_activity(activity)"></template><template v-else>{{ activity.endedDate }}</template></td>
                                                <td  v-if="show_user_performance === true">
                                                    <v-btn v-if="activity.endedDate && has_restart_activity(activity) == false" small @click="restart_activity(activity)" color="primary">
                                                        <v-icon left>restart_alt</v-icon>{{ trans('users_targets_progressions.actions.restart_activities') }}
                                                    </v-btn>
                                                    <v-btn v-if="has_restart_activity(activity)" small @click="revert_restart_activity(activity)" color="primary">
                                                        <v-icon left>reply</v-icon>{{ trans('users_targets_progressions.actions.cancel') }}
                                                    </v-btn>
                                                </td>

                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                    <v-container v-if="notes.length > 0">
                        <v-row>
                        <v-col cols="12" md="12" class="formSubSection">
                            {{ trans('targets.fields.notes') }}
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th width="10%">{{ trans('users_targets_notes.fields.date') }}</th>
                                                <th width="70%">{{ trans('users_targets_notes.fields.note') }}</th>
                                                <th width="20%">{{ trans('users_targets_notes.fields.author') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(u_note, nid) in notes" :key="nid">
                                                <td width="10%">{{ u_note.datetime }}</td>
                                                <td width="70%">{{ u_note.note }}</td>
                                                <td width="20%">{{ u_note.author_name }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" class="formSubSection">
                                {{ trans('users_targets_progressions.fields.user_performance_section') }}
                            </v-col>
                        </v-row>
                    </v-container>
                        <v-container v-if="show_user_performance === true">

                                <v-row v-if="performance.evaluation_date !== null">
                                    <v-col cols="6" md="6">
                                        {{ trans('users_performances.fields.evaluation_date') }} : {{ performance.evaluation_date | date }}
                                    </v-col>
                                    <!-- <v-col cols="6" md="6">
                                        //TODO trasformarlo in select
                                        {{ trans('users_performances.fields.user_evaluation') }} : {{ performance.user_evaluation }}
                                    </v-col> -->
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="6" md="6">
                                        <v-slider
                                            :label="trans('users_performances.fields.quality') + '*'"
                                            :rules="FormRuleHelper.numericRule(performance.quality, false, 0, 100)"
                                            v-model="performance.quality"
                                            :thumb-size="24"
                                            step="0.5"
                                            max="10"
                                            thumb-label="always"
                                            id="quality"
                                            name="quality"
                                        ></v-slider>

                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-slider
                                            :label="trans('users_performances.fields.satisfation') + '*'"
                                            :rules="FormRuleHelper.numericRule(performance.satisfation, false, 0, 100)"
                                            v-model="performance.satisfation"
                                            :thumb-size="24"
                                            step="0.5"
                                            max="10"
                                            thumb-label="always"
                                            id="satisfation"
                                            name="satisfation"
                                        ></v-slider>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <v-slider
                                            :label="trans('users_performances.fields.efficiency') + '*'"
                                            :rules="FormRuleHelper.numericRule(performance.efficiency, false, 0, 100)"
                                            v-model="performance.efficiency"
                                            :thumb-size="24"
                                            step="0.5"
                                            max="10"
                                            thumb-label="always"
                                            id="efficiency"
                                            name="efficiency"
                                        ></v-slider>
                                    </v-col>
                                </v-row>
                        </v-container>
                        <v-container v-else>
                            <v-row>
                                <v-col cols="6" md="6">
                                    <br>
                                    <v-btn color="primary" @click="show_user_performance = true">
                                        <v-icon left>task_alt</v-icon> {{ trans('users_targets_progressions.actions.compile') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>

                    </v-container>

                    <small><b>*</b>&nbsp;{{ trans('common.required-field') }}</small>
                    <v-text-field v-model="data_user_id"
                                    :hidden="true" style="width: 0px;"
                                    name="user_id"
                                    id="user_id"
                                    >
                    </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <a :href="cancel_action">
                        <v-btn color="gray">
                            <v-icon right>arrow_back</v-icon>&nbsp; {{ trans('users_targets_progressions.actions.cancel') }}
                        </v-btn>
                    </a>
                    <v-spacer>
                    </v-spacer>
                    <v-btn @click="submit" :disabled="!canSubmit" color="primary">
                        <v-icon left>send</v-icon>{{ trans('users_targets_progressions.actions.save') }}
                    </v-btn>
                </v-card-actions>

        </v-card>
    </v-container>
</template>
<script>

import FormRuleHelper from '../../../FormRuleHelpers.js';

export default {

    name: "user-target-progression-edit",
    props: {

        title: { default: '' },
        target_progression: { type: Object },
        users_activities:  { type: Array },
        user_performance: { type: Object },
        user_target_notes: { type: Array },
        form_errors: { default: [] },
        form_action: { default: '' },
        cancel_action: { default: ''},
        user_id: { default: '' }

    },

    data() {

        //let data = {}; // todo - add default schema
        //data = Object.assign(data, this.target || {});

        let data = this.target_progression;
        let activities = this.users_activities;
        let performance = this.user_performance;
        let notes = this.user_target_notes;

        let errors = Object.entries(this.form_errors);
        let error = null;
        let show_user_performance = false;
        if(performance.id !== null) {
            show_user_performance = true;
        }


        let data_user_id = this.user_id;

        return {
            data,
            activities,
            performance,
            notes,
            FormRuleHelper,
            errors: errors,
            error,
            changed: false,
            valid: false,
            loading: false,
            show_user_performance,
            restart_activities: [],
            data_user_id


        };
    },

    methods: {



        restart_activity(activity) {


            // alert(JSON.stringify(this.dummy_activities));


            let index_restart = this.restart_activities.indexOf(activity.id);
            if (index_restart > -1) {
                this.restart_activities.splice(index_restart, 1); // remove one item only
            }
            this.restart_activities.push(activity.id);
            this.changed = true;
        },



        has_restart_activity(activity) {
            let index_restart = this.restart_activities.indexOf(activity.id);
            if (index_restart > -1) {
                return true;
            }
            return false;
        },


        revert_restart_activity(activity) {
            let index_restart = this.restart_activities.indexOf(activity.id);
            if (index_restart > -1) {
                this.restart_activities.splice(index_restart, 1); // remove one item only
            }

        },



        human_worked_time(worked_time) {

            let num_worked_time = parseFloat(worked_time);
            let hours_worked_time = 0;
            let f_hours_worked_time = 0;
            let r_hours_worked_time = 0;
            let min_worked_time = 0;
            let f_min_worked_time = 0;
            let r_min_worked_time = 0;
            let sec_worked_time = 0;

            if(num_worked_time > 0) {
                f_hours_worked_time = num_worked_time / 3600;
                r_hours_worked_time = num_worked_time % 3600;
                hours_worked_time = parseInt(f_hours_worked_time);
            }

            if(r_hours_worked_time > 0) {
                f_min_worked_time = r_hours_worked_time / 60;
                r_min_worked_time = r_hours_worked_time % 60;
                min_worked_time = parseInt(f_min_worked_time);
            }

            if(r_min_worked_time > 0) {
                sec_worked_time = r_min_worked_time;
            }



            let result = hours_worked_time + ' ' + trans('common.times.hours') + ' ' + min_worked_time + ' ' + trans('common.times.minutes') + ' ' + sec_worked_time + ' ' + trans('common.times.seconds');

            return result;
},
        async submit() {

            window.onbeforeunload = true;
            this.error = null;
            this.loading = true;

            return await this.putData();





        },

        async postData() {

            let url = this.form_action;


            await axios.post(
                url,
                this.performance,
            )
                .then((response) => {
                    if (response.data && response.data.status == 'ok' && response.data.redirect) {
                        window.location.href = response.data.redirect;
                    }
                })
                .catch((error) => {

                    this.error = error.response.data.errors;
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        async putData() {

            let url = this.form_action;

            let payload = {'performance': this.performance, 'restart_activities': this.restart_activities, 'user_id': this.data_user_id };

            await axios.put(
                url,
                payload
            )
                .then((response) => {
                    if (response.data && response.data.status == 'ok' && response.data.redirect) {
                        window.location.href = response.data.redirect;
                    }
                })
                .catch((error) => {
                    this.error = error.response.data.errors;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

    },

    computed: {
        canSubmit() {
            return this.show_user_performance === false || (this.changed && this.valid);
        },

        user_target_worked_time_cost() {
            return this.data.user_target_worked_time * this.data.target_hourly_budget;
        },






    },


    watch: {

        performance: {
            deep: true,
            handler() {
                this.changed = true;
            }
        }

    },

    /*
    watch: {
        data: {
            handler: function (newValue) {
                this.changed = true;

                window.onbeforeunload = function (e) {
                    return trans('common.confirm-exit-page');
                };
            },
            deep: true
        },
    },
    */


    components: {
    }

}
</script>
